import React, { useState, useEffect } from "react";
import axios from "axios";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import "./Footer.css";
import Loader from "./Loader";

const Footer = props => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [post, setPost] = useState({});

  const loadFooterContent = (pageId = 77) => {
    const getUrl = `http://admin.kapoff.se/wp-json/wp/v2/pages/${pageId}`;
    axios
      .get(getUrl)
      .then(res => {
        setPost(res.data);
        setIsLoaded(true);
      })
      .catch(err => console.log(err));
  };

  useEffect(() => {
    loadFooterContent();
  }, []);

  if (isLoaded) {
    return (
      <footer>
        <Container>
          <Row>
            <Col>
              <div
                dangerouslySetInnerHTML={{ __html: post.content.rendered }}
              />
            </Col>
          </Row>
          <Row>
            <Col xs="12">{props.children}</Col>
          </Row>
        </Container>
      </footer>
    );
  }
  return (
    <footer>
      <Row>
        <Col xs="12" className="text-center">
          <Loader />
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx